import React from 'react';

import Typography from '../../../../../../library/typography/typography';
import FoundItLowerButton, {
  FoundItLowerTheme
} from '../../../../../../components/found-it-lower-button/found-it-lower-button';
import MinimumPriceMessage from '../../../../../../components/minimum-price-message/minimum-price-message';
import ParentProductMessage from '../../../../../../components/parent-product-message/parent-product-message';
import ProductDescription from '../../../../../../components/product-description/product-description';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../../../components/quantity-disclaimer/quantity-disclaimer';
import ProductListCardPrice from '../../../product-list-card-price/product-list-card-price';

import { useMediaQuery } from '../../../../../../shared/hooks/hooks';

import {
  getNormalizedProductType,
  getShouldShowMinimumPriceMessage
} from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';

import styles from './product-list-staggered-card-axle.scss';

interface ProductListStaggeredCardAxleProps {
  defaultQuantity?: number;
  label: string;
  onQuantityChange: (e: Event, number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListStaggeredCardAxle(
  props: ProductListStaggeredCardAxleProps
) {
  const {
    defaultQuantity = 2,
    label,
    onQuantityChange,
    product,
    quantity,
    totalQuantity
  } = props;
  const { isMinSm } = useMediaQuery();

  const { mapDisplayRule, size } = product || {};
  const productType = getNormalizedProductType(product?.productType);

  const showMinimumPriceMessage = getShouldShowMinimumPriceMessage(product);

  return (
    <div className={styles['container']}>
      <Typography className={styles['label']} tag="span">
        {label}:&nbsp; <ProductDescription size={size} />
      </Typography>
      <div className={styles['price-qty-container']}>
        <div className={styles['price-container']}>
          <ProductListCardPrice
            hideFoundItLower
            hideParentMessage
            hidePercentageSaved
            product={product}
            quantity={quantity}
            totalQuantity={totalQuantity}
          />
        </div>

        <ProductQuantity
          defaultValue={defaultQuantity}
          id="quantity"
          isHorizontal
          max={2}
          onBlur={onQuantityChange}
          onChange={onQuantityChange}
          showLabel={
            process.env.__FF_PLP_CONDENSED_CARDS__ === 'true' ? isMinSm : true
          }
          value={quantity}
        />
      </div>
      <FoundItLowerButton
        hideIcon={!isMinSm && process.env.__FF_PLP_CONDENSED_CARDS__ === 'true'}
        hideMatchItText={
          !isMinSm && process.env.__FF_PLP_CONDENSED_CARDS__ === 'true'
        }
        productItem={{
          product: product,
          quantity: quantity,
          totalQuantity: totalQuantity
        }}
        theme={
          process.env.__FF_PLP_CONDENSED_CARDS__ === 'true'
            ? FoundItLowerTheme.BLUE
            : FoundItLowerTheme.GREY
        }
      />
      <ParentProductMessage
        className={styles['parent-product-message']}
        product={product}
      />
      {showMinimumPriceMessage && (
        <MinimumPriceMessage message={mapDisplayRule?.message} />
      )}
      <QuantityDisclaimer
        className={styles['quantity-disclaimer']}
        productType={productType}
        quantity={quantity}
      />
    </div>
  );
}

export default ProductListStaggeredCardAxle;
